import { render, staticRenderFns } from "./customers_page.vue?vue&type=template&id=3c0dd422"
import script from "./customers_page.vue?vue&type=script&lang=js"
export * from "./customers_page.vue?vue&type=script&lang=js"
import style0 from "./customers_page.vue?vue&type=style&index=0&id=3c0dd422&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports